export default __webpack_public_path__ + "static/media/ico-landing.cde887ba.svg";